export const style = {
  boxContainer: {
    icon: {
      height: 24,
      width: 24,
    },
    sx: {
      display: 'flex',
      alignItems: 'center',
      gap: 1,
    },
    boxRow: {
      sx: {
        color: 'text.secondary',
        display: 'flex',
        alignItems: 'center',
        height: 20,
      },
    },
    Typography: {
      variant: 'caption',
      text: 'text.secondary',
    },
  },
} as const;
